<template lang="pug">
div.admin-layout
  //- DrugStorageSummary
  div.empty-layout(
    v-if="tagSystems.length === 0"
  )
    img(src="/static/svg/empty-inbox.svg") 
    p 無標籤系統資料

  div(v-else)
    h6  標籤系統清單
    div.row
      div.input-group.col-6
        div.input-group-prepend
          span.input-group-text 選擇系統
        select.form-control(v-model="tagId" @change="setCurrentTag")
          option(v-for="tag, num in tagSystems" :value="num") {{tag.name}}
      div.input-group.col-6
        div.input-group-prepend
          span.input-group-text 選擇欄位
        select.form-control(v-model="netId" @change="setCurrentNet")
          option(v-for="net, num in nets" :value="num") {{net.row_id}} 
    hr
    div(v-show="netId !== ''")
      button.btn.btn-info.icon-right(@click="popCreateForm") 新增藥物儲存
      CreateDrugStorageForm(v-if="createForm" :devices="devices" v-on:cancelForm="cancelForm")
      vuetable(
        ref="vuetable"
        :api-url="`${server}/api/drug-storage/`"
        data-path="results"
        :fields="fields"
        :http-options="httpOptions"
        pagination-path=""
        :css="boostrapCss"
        :append-params="moreParams"
        :perPage="20"
        :sortOrder="sortOrder"
        @vuetable:pagination-data="onPaginationData"
        track-by="id"
      )
      vuetable-pagination(
        ref="pagination"
        @vuetable-pagination:change-page="onChangePage"
        :css="boostrapCss.pagination" 
      )

</template>

<script>
import Vue from 'vue';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import readCookie from '@/vuex/functions/readCookie';
import server, { TaskWebSocketServer } from '@/config';
// import DrugDetail from './DrugDetail';
import Confirm from '../../common/Confirm';
import CreateDrugStorageForm from '../../common/CreateDrugStorageForm';


// Vue.component('tag-drug-detail', DrugDetail);
Vue.component('delete-drug-storage', {
  name: 'DeleteDrugStorage',
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  data() {
    return {
      confirm: false,
    };
  },
  components: {
    Confirm,
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  template: `
    <div>
      <button class="btn btn-danger btn-sm" @click="del">刪除</button>
      <Confirm v-show="confirm" :message="'確定刪除?'" v-on:response="confirmDel" />
    </div>
  `,
  methods: {
    confirmDel(response) {
      this.confirm = false;
      if (response) {
        this.instance.delete(`/api/drug-storage/${this.rowData.id}/`, {
          data: {
            type: 'ADMIN_DELETE',
          },
        })
        .then((res) => {
          this.$parent.refresh();
        })
        .then(() => {
          this.$parent.$parent.getTagSystem()
          .then(() => {
            console.log('reset net');
            this.$parent.$parent.setCurrentTag();
            this.$parent.$parent.setCurrentNet();
          });
        });
      }
    },
    del() {
      this.confirm = true;
    },
  },
});


export default {
  name: 'TagDrugList',
  components: {
    Vuetable,
    VuetablePagination,
    CreateDrugStorageForm,
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
    drugStorageChangeTime() {
      return this.$store.getters.drugStorageChangeTime;
    },
  },
  data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      fields: [
        {
          name: 'device.series',
          sortField: 'device__pos_col',
          title: '位置',
        },
        {
          name: 'medication.CGMH_number',
          title: '料位號',
        },
        {
          name: 'medication.generic_name',
          title: '藥名',
        },
        {
          name: 'stock',
          title: '庫存',
        },
        {
          name: 'max_stock',
          title: '最大庫存',
        },
        // {
        //   name: 'expired_date',
        //   title: '有效期限',
        // },
        // {
        //   name: 'patch_number',
        //   title: '批號',
        // },
        {
          name: 'inventoried_in_tag_system',
          title: '盤點與否',
          callback: 'booleanToZh',
        },
        {
          name: '__component:delete-drug-storage',
          title: '刪除',
        },
      ],
      sortOrder: [
        {
          sortField: 'device__pos_col',
          direction: 'asc',
        },
      ],
      server,
      moreParams: {},
      tagSystems: [],
      tagId: '',
      currentTag: {},
      nets: [],
      netId: '',
      currentNet: {},
      devices: [],
      deviceId: null,
      currentDevice: {},
      createForm: false,
      searchDrug: '',
      medicines: [],
      currentMedicine: {},
      stock: 0,
      maxStock: 0,
      inventoried: false,
      date: null,
      batch: '',
      currentTagContainMed: false,
    };
  },
  mounted() {
    this.getTagSystem();
    // this.webSocketForUpdate();
  },
  methods: {
    getSortParam(sortOrder) {
      return sortOrder.map((sort) => {
        return (sort.direction === 'desc' ? '-' : '') + sort.sortField;
      }).join(',');
    },
    booleanToZh(val) {
      return val === true ? '是' : '否';
    },
    getTagSystem() {
      return this.instance.get('/api/system/', {
        params: {
          type: 'Tag',
        },
      })
      .then((res) => {
        this.tagSystems = res.data.results;
      });
    },
    getCurrentTag(id) {
      return this.instance.get(`/api/system/${id}/`);
    },
    setCurrentTag() {
      this.getCurrentTag(this.tagSystems[this.tagId].id)
      .then((res) => {
        console.log(res);
        this.currentTag = res.data;
        this.nets = this.currentTag.net_set;
      })
      .catch((err) => {
        this.$store.commit('SET_MESSAGES', {
          type: 'error',
          content: '選擇系統資料有誤',
        });
      });
    },
    setCurrentNet() {
      this.currentNet = this.nets[this.netId];
      this.moreParams.device__net = this.currentNet.id;
      this.devices = [];
      this.nets[this.netId].device_set.forEach((d) => {
        if (d.drugstorage_set.length === 0) {
          this.devices.push(d);
        }
      });
      // handling the first time vuetable was hidden
      this.$refs.vuetable.refresh();
    },
    onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    checkFormFilled() {
      if (Object.keys(this.currentMedicine).length !== 0 && this.stock !== 0 && this.maxStock !== 0) {
        return true;
      }
      return false;
    },
    checkMedExists(medId) {
      this.instance.get('/api/drug-storage/', {
        params: {
          device__net__system: this.$store.state.device.systemId,
          med_id: medId,
        },
      })
      .then((res) => {
        if (res.data.results.length > 0) {
          return true;
        }
        return false;
      });
    },
    popCreateForm() {
      if (this.devices.length > 0) {
        this.createForm = true;
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '此欄位已無空間新增藥物',
        });
      }
    },
    cancelForm() {
      this.createForm = false;
    },
  },
  watch: {
    searchDrug(val) {
      if (val.length >= 3 && this.searchDrug !== this.currentMedicine.generic_name) {
        this.instance.get('/api/medication/', {
          params: {
            search: val,
          },
        })
        .then((res) => {
          this.medicines = res.data.results;
        });
      } else {
        this.medicines = [];
      }
    },
    drugStorageChangeTime() {
      this.$refs.vuetable.refresh();
    },
  },
};
</script>

<style lang="sass">


    


</style>



// WEBPACK FOOTER //
// DrugList.vue?7688dd38